import React from "react";
import { Icon } from "./Icon";
import { Button } from "./Button";
import { ComponentColor } from "./types";

interface ErrorStateProps {
    /** Headline shown above the message. */
    title?: string;
    /** Explanatory copy. */
    message?: string;
    /** Material Symbol name for the leading icon. */
    icon?: string;
    /** When provided, renders a primary Retry button that invokes this. */
    onRetry?: () => void;
}

export const ErrorState = ({
    title,
    message = "Couldn't load this content.",
    icon = "cloud_off",
    onRetry,
}: ErrorStateProps): React.JSX.Element => {
    return (
        <div
            role="alert"
            className="flex flex-col items-center justify-center gap-3 py-12 text-center text-neutral"
        >
            <Icon name={icon} className="text-5xl text-neutral/60" />
            {title && (
                <p className="text-lg font-semibold text-neutral">{title}</p>
            )}
            <p className="text-neutral/80">{message}</p>
            {onRetry && (
                <Button color={ComponentColor.Primary} onClick={onRetry}>
                    Retry
                </Button>
            )}
        </div>
    );
};
